// ABOUTME: Lightning bolt icon with gradient background for auto-calculation features
// ABOUTME: Used for automated/dynamic functionality indicators

interface IconProps {
  className?: string
  size?: number
}

export const LightningAutoIcon = ({ className = "", size = 17 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="0.59668"
      width="16.4033"
      height="16.4033"
      rx="8"
      fill="url(#paint0_linear_lightning_auto)"
    />
    <g clipPath="url(#clip0_lightning_auto)">
      <path
        d="M12.6472 8.42589L8.05424 13.3469C8.00556 13.3988 7.94132 13.4335 7.87119 13.4458C7.80107 13.458 7.72887 13.4471 7.66549 13.4147C7.60211 13.3823 7.55099 13.3301 7.51985 13.2661C7.4887 13.2021 7.47922 13.1297 7.49283 13.0598L8.09401 10.0527L5.73071 9.16527C5.67995 9.14629 5.63469 9.11503 5.59896 9.07428C5.56324 9.03353 5.53816 8.98457 5.52598 8.93177C5.51379 8.87897 5.51488 8.82397 5.52914 8.77169C5.54339 8.71941 5.57038 8.67147 5.60768 8.63217L10.2006 3.71117C10.2493 3.65923 10.3135 3.62452 10.3837 3.6123C10.4538 3.60007 10.526 3.61099 10.5894 3.64339C10.6527 3.6758 10.7039 3.72794 10.735 3.79195C10.7661 3.85596 10.7756 3.92836 10.762 3.99823L10.1592 7.00865L12.5225 7.89484C12.5729 7.91395 12.6178 7.94518 12.6532 7.98576C12.6887 8.02635 12.7136 8.07504 12.7257 8.12753C12.7379 8.18003 12.7369 8.23471 12.723 8.28675C12.709 8.33878 12.6824 8.38657 12.6455 8.42589H12.6472Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_lightning_auto"
        x1="0.59668"
        y1="8.20166"
        x2="17"
        y2="8.20166"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#66B6FF" />
        <stop
          offset="1"
          stopColor="#93D8FF"
        />
      </linearGradient>
      <clipPath id="clip0_lightning_auto">
        <rect
          width="10.4981"
          height="10.4981"
          fill="white"
          transform="translate(3.87695 3.28125)"
        />
      </clipPath>
    </defs>
  </svg>
)
